import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [language, setLanguage] = useState('en');

  const translations = {
    en: {
      nav: {
        home: 'Home',
        services: 'Services',
        about: 'About',
        contact: 'Contact',
        cta: 'Get in Touch'
      },
      hero: {
        badge: 'Swiss Excellence in Digital Marketing',
        title1: 'Digital Marketing Strategy &',
        title2: 'Talent Management',
        description: 'We provide strategy consulting, content coordination and brand communication services for social media platforms including Instagram and TikTok.',
        cta1: 'Book a Consultation',
        cta2: 'Learn More About Our Services'
      },
      about: {
        title: 'About IMAT92 Sagl',
        subtitle: 'Professional consulting services in digital marketing and social media strategy',
        text1: 'IMAT92 SAGL is a Swiss-based company providing professional consulting services in digital marketing and social media strategy. We work with both individual professionals and brands to improve strategic visibility and communication on social media platforms such as Instagram and TikTok.',
        text2: 'We are committed to transparent business practices and operate internationally with a focus on strategic growth and measurable outcomes.',
        text3: 'IMAT92 SAGL operates exclusively as a consulting and coordination company in the digital marketing space.',
        card1Title: 'Swiss Registered',
        card1Text: 'Officially registered in Switzerland (CHE-447.388.222), operating under Swiss business regulations and standards of professionalism.',
        card2Title: 'Strategic Focus',
        card2Text: 'Specialized in social media strategy for Instagram and TikTok platforms with data-driven approaches and measurable results.',
        card3Title: 'Professional Standards',
        card3Text: 'Commitment to transparency, efficiency, and ethical business practices in all client relationships.'
      },
      services: {
        title: 'Our Services',
        subtitle: 'Comprehensive digital marketing and talent management solutions',
        service1Title: 'Marketing & Strategy Consulting',
        service1Desc: 'IMAT92 SAGL offers expert consulting to help individuals and businesses optimize their social media presence. Our services include strategic planning tailored to your specific goals and target audience.',
        service1Item1: 'Social media strategy tailored to your goals',
        service1Item2: 'Audience and target analysis',
        service1Item3: 'Brand positioning and messaging',
        service1Item4: 'Growth and performance optimization',
        service2Title: 'Content & Communication Management',
        service2Desc: 'We support clients in planning and managing high-quality content that aligns with strategic objectives. Our approach ensures consistency and effectiveness across all communication channels.',
        service2Item1: 'Content planning and calendar development',
        service2Item2: 'Creative direction for visual and written content',
        service2Item3: 'Coordination of production and editing',
        service2Item4: 'Communication guidelines and performance tracking',
        service3Title: 'Talent & Brand Mediation',
        service3Desc: 'IMAT92 SAGL acts as a professional liaison between talent and brands, facilitating successful partnerships and ensuring smooth collaboration throughout campaign execution.',
        service3Item1: 'Talent scouting for marketing campaigns',
        service3Item2: 'Matching creators with suitable brand partners',
        service3Item3: 'Campaign communication management',
        service3Item4: 'Support in negotiation and execution',
        service4Title: 'How We Work',
        service4Desc: 'IMAT92 SAGL has a structured and transparent approach to deliver measurable results. We guide clients through every step of the process with clear communication and data-driven decision making.',
        service4Item1: 'Client Onboarding & Analysis',
        service4Item2: 'Strategy Definition',
        service4Item3: 'Content & Communication Planning',
        service4Item4: 'Execution Coordination',
        service4Item5: 'Reporting & Optimization'
      },
      contact: {
        title: 'Contact Information',
        intro: 'If you are interested in working with us or want to learn more about our services, please reach out through the following channels.',
        companyName: 'Company Name',
        regNumber: 'Registration Number',
        address: 'Address',
        email: 'Email',
        formTitle: 'Send us a Message',
        formName: 'Name',
        formEmail: 'Email',
        formCompany: 'Company/Project',
        formMessage: 'Message',
        formSubmit: 'Submit'
      },
      footer: {
        tagline: 'Professional digital marketing and talent management services from Switzerland',
        copyright: 'All rights reserved.',
        disclaimer: 'This website provides information about IMAT92 Sagl\'s consulting and marketing services. We do not host or distribute user-generated content on this website.'
      },
      mobile: {
        footerText: 'Swiss Excellence in Digital Marketing'
      }
    },
    it: {
      nav: {
        home: 'Home',
        services: 'Servizi',
        about: 'Chi Siamo',
        contact: 'Contatti',
        cta: 'Contattaci'
      },
      hero: {
        badge: 'Eccellenza Svizzera nel Marketing Digitale',
        title1: 'Strategia di Marketing Digitale e',
        title2: 'Gestione dei Talenti',
        description: 'Forniamo servizi di consulenza strategica, coordinamento dei contenuti e comunicazione del brand per piattaforme di social media tra cui Instagram e TikTok.',
        cta1: 'Prenota una Consulenza',
        cta2: 'Scopri i Nostri Servizi'
      },
      about: {
        title: 'Chi è IMAT92 Sagl',
        subtitle: 'Servizi di consulenza professionale nel marketing digitale e strategia per i social media',
        text1: 'IMAT92 SAGL è un\'azienda svizzera che fornisce servizi di consulenza professionale nel marketing digitale e strategia per i social media. Lavoriamo sia con professionisti individuali che con brand per migliorare la visibilità strategica e la comunicazione su piattaforme social come Instagram e TikTok.',
        text2: 'Ci impegniamo a pratiche commerciali trasparenti e operiamo a livello internazionale con un focus sulla crescita strategica e risultati misurabili.',
        text3: 'IMAT92 SAGL opera esclusivamente come azienda di consulenza e coordinamento nello spazio del marketing digitale.',
        card1Title: 'Registrata in Svizzera',
        card1Text: 'Ufficialmente registrata in Svizzera (CHE-447.388.222), operante secondo le normative commerciali svizzere e standard di professionalità.',
        card2Title: 'Focus Strategico',
        card2Text: 'Specializzati nella strategia per i social media sulle piattaforme Instagram e TikTok con approcci basati sui dati e risultati misurabili.',
        card3Title: 'Standard Professionali',
        card3Text: 'Impegno alla trasparenza, efficienza e pratiche commerciali etiche in tutte le relazioni con i clienti.'
      },
      services: {
        title: 'I Nostri Servizi',
        subtitle: 'Soluzioni complete di marketing digitale e gestione dei talenti',
        service1Title: 'Consulenza Marketing e Strategia',
        service1Desc: 'IMAT92 SAGL offre consulenza esperta per aiutare individui e aziende a ottimizzare la loro presenza sui social media. I nostri servizi includono pianificazione strategica su misura per i vostri obiettivi specifici e pubblico di riferimento.',
        service1Item1: 'Strategia social media personalizzata sui tuoi obiettivi',
        service1Item2: 'Analisi del pubblico e del target',
        service1Item3: 'Posizionamento del brand e messaggistica',
        service1Item4: 'Ottimizzazione della crescita e delle performance',
        service2Title: 'Gestione Contenuti e Comunicazione',
        service2Desc: 'Supportiamo i clienti nella pianificazione e gestione di contenuti di alta qualità che si allineano agli obiettivi strategici. Il nostro approccio garantisce coerenza ed efficacia su tutti i canali di comunicazione.',
        service2Item1: 'Pianificazione contenuti e sviluppo calendario',
        service2Item2: 'Direzione creativa per contenuti visivi e scritti',
        service2Item3: 'Coordinamento di produzione ed editing',
        service2Item4: 'Linee guida di comunicazione e monitoraggio performance',
        service3Title: 'Mediazione Talenti e Brand',
        service3Desc: 'IMAT92 SAGL agisce come collegamento professionale tra talenti e brand, facilitando partnership di successo e garantendo una collaborazione fluida durante l\'esecuzione delle campagne.',
        service3Item1: 'Scouting dei talenti per campagne marketing',
        service3Item2: 'Matching dei creator con partner brand adatti',
        service3Item3: 'Gestione della comunicazione delle campagne',
        service3Item4: 'Supporto nella negoziazione ed esecuzione',
        service4Title: 'Come Lavoriamo',
        service4Desc: 'IMAT92 SAGL ha un approccio strutturato e trasparente per fornire risultati misurabili. Guidiamo i clienti attraverso ogni fase del processo con comunicazione chiara e decisioni basate sui dati.',
        service4Item1: 'Onboarding Cliente e Analisi',
        service4Item2: 'Definizione della Strategia',
        service4Item3: 'Pianificazione Contenuti e Comunicazione',
        service4Item4: 'Coordinamento dell\'Esecuzione',
        service4Item5: 'Reporting e Ottimizzazione'
      },
      contact: {
        title: 'Informazioni di Contatto',
        intro: 'Se sei interessato a lavorare con noi o vuoi saperne di più sui nostri servizi, contattaci attraverso i seguenti canali.',
        companyName: 'Nome Azienda',
        regNumber: 'Numero di Registrazione',
        address: 'Indirizzo',
        email: 'Email',
        formTitle: 'Inviaci un Messaggio',
        formName: 'Nome',
        formEmail: 'Email',
        formCompany: 'Azienda/Progetto',
        formMessage: 'Messaggio',
        formSubmit: 'Invia'
      },
      footer: {
        tagline: 'Servizi professionali di marketing digitale e gestione talenti dalla Svizzera',
        copyright: 'Tutti i diritti riservati.',
        disclaimer: 'Questo sito web fornisce informazioni sui servizi di consulenza e marketing di IMAT92 Sagl. Non ospitiamo né distribuiamo contenuti generati dagli utenti su questo sito web.'
      },
      mobile: {
        footerText: 'Eccellenza Svizzera nel Marketing Digitale'
      }
    }
  };

  const t = translations[language];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'it' : 'en');
  };

  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId).scrollIntoView({ 
      behavior: 'smooth' 
    });
    setMobileMenuOpen(false);
  };

  return (
    <div className="App">
      {/* Navigation Bar */}
      <nav className={`navbar ${isScrolled ? 'navbar-scrolled' : ''}`}>
        <div className="container">
          <div className="nav-content">
            <div className="logo">
              <span className="logo-text">IMAT92 Sagl</span>
            </div>
            <ul className="nav-links">
              <li><button onClick={() => scrollToSection('home')} className="nav-link">{t.nav.home}</button></li>
              <li><button onClick={() => scrollToSection('services')} className="nav-link">{t.nav.services}</button></li>
              <li><button onClick={() => scrollToSection('about')} className="nav-link">{t.nav.about}</button></li>
              <li><button onClick={() => scrollToSection('contact')} className="nav-link">{t.nav.contact}</button></li>
            </ul>
            <div className="nav-cta">
              <button onClick={toggleLanguage} className="lang-toggle" aria-label="Toggle language">
                {language === 'en' ? 'IT' : 'EN'}
              </button>
              <button onClick={() => scrollToSection('contact')} className="cta-btn">{t.nav.cta}</button>
            </div>
            <button 
              className={`mobile-menu-toggle ${mobileMenuOpen ? 'active' : ''}`}
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="Toggle menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
        
        {/* Mobile Menu Overlay */}
        <div className={`mobile-menu ${mobileMenuOpen ? 'active' : ''}`}>
          <div className="mobile-menu-content">
            <nav className="mobile-nav">
              <button onClick={() => scrollToSection('home')} className="mobile-nav-link">
                <span className="mobile-nav-number">01</span>
                <span className="mobile-nav-text">{t.nav.home}</span>
              </button>
              <button onClick={() => scrollToSection('services')} className="mobile-nav-link">
                <span className="mobile-nav-number">02</span>
                <span className="mobile-nav-text">{t.nav.services}</span>
              </button>
              <button onClick={() => scrollToSection('about')} className="mobile-nav-link">
                <span className="mobile-nav-number">03</span>
                <span className="mobile-nav-text">{t.nav.about}</span>
              </button>
              <button onClick={() => scrollToSection('contact')} className="mobile-nav-link">
                <span className="mobile-nav-number">04</span>
                <span className="mobile-nav-text">{t.nav.contact}</span>
              </button>
            </nav>
            <div className="mobile-menu-footer">
              <p>{t.mobile.footerText}</p>
              <button onClick={toggleLanguage} className="mobile-lang-toggle">
                {language === 'en' ? '🇮🇹 Italiano' : '🇬🇧 English'}
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero" id="home">
        <div className="container">
          <div className="hero-content">
            <div className="hero-badge">{t.hero.badge}</div>
            <h1 className="hero-title">
              {t.hero.title1}<br />
              <span className="title-accent">{t.hero.title2}</span>
            </h1>
            <p className="hero-description">
              {t.hero.description}
            </p>
            <div className="hero-cta">
              <button onClick={() => scrollToSection('contact')} className="btn-primary">
                {t.hero.cta1}
              </button>
              <button onClick={() => scrollToSection('services')} className="btn-secondary">
                {t.hero.cta2}
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about" id="about">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">{t.about.title}</h2>
            <p className="section-subtitle">
              {t.about.subtitle}
            </p>
          </div>
          <div className="about-content">
            <div className="about-main">
              <p className="about-text">
                {t.about.text1}
              </p>
              <p className="about-text">
                {t.about.text2}
              </p>
              <p className="about-text">
                {t.about.text3}
              </p>
            </div>
            
            <div className="about-cards">
              <div className="info-card">
                <div className="card-header">
                  <h3>{t.about.card1Title}</h3>
                </div>
                <p>
                  {t.about.card1Text}
                </p>
              </div>
              <div className="info-card">
                <div className="card-header">
                  <h3>{t.about.card2Title}</h3>
                </div>
                <p>
                  {t.about.card2Text}
                </p>
              </div>
              <div className="info-card">
                <div  className="card-header">
                  <h3>{t.about.card3Title}</h3>
                </div>
                <p>
                  {t.about.card3Text}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services" id="services">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">{t.services.title}</h2>
            <p className="section-subtitle">
              {t.services.subtitle}
            </p>
          </div>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-number">01</div>
              <h3 className="service-title">{t.services.service1Title}</h3>
              <p className="service-description">
                {t.services.service1Desc}
              </p>
              <ul className="service-list">
                <li>{t.services.service1Item1}</li>
                <li>{t.services.service1Item2}</li>
                <li>{t.services.service1Item3}</li>
                <li>{t.services.service1Item4}</li>
              </ul>
            </div>

            <div className="service-card">
              <div className="service-number">02</div>
              <h3 className="service-title">{t.services.service2Title}</h3>
              <p className="service-description">
                {t.services.service2Desc}
              </p>
              <ul className="service-list">
                <li>{t.services.service2Item1}</li>
                <li>{t.services.service2Item2}</li>
                <li>{t.services.service2Item3}</li>
                <li>{t.services.service2Item4}</li>
              </ul>
            </div>

            <div className="service-card">
              <div className="service-number">03</div>
              <h3 className="service-title">{t.services.service3Title}</h3>
              <p className="service-description">
                {t.services.service3Desc}
              </p>
              <ul className="service-list">
                <li>{t.services.service3Item1}</li>
                <li>{t.services.service3Item2}</li>
                <li>{t.services.service3Item3}</li>
                <li>{t.services.service3Item4}</li>
              </ul>
            </div>

            <div className="service-card">
              <div className="service-number">04</div>
              <h3 className="service-title">{t.services.service4Title}</h3>
              <p className="service-description">
                {t.services.service4Desc}
              </p>
              <ul className="service-list">
                <li>{t.services.service4Item1}</li>
                <li>{t.services.service4Item2}</li>
                <li>{t.services.service4Item3}</li>
                <li>{t.services.service4Item4}</li>
                <li>{t.services.service4Item5}</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact" id="contact">
        <div className="container">
          <div className="contact-content">
            <div className="contact-info">
              <h2 className="section-title">{t.contact.title}</h2>
              <p className="contact-intro">
                {t.contact.intro}
              </p>
              
              <div className="contact-details">
                <div className="contact-item">
                  <h3>{t.contact.companyName}</h3>
                  <p>IMAT92 SAGL</p>
                </div>
                <div className="contact-item">
                  <h3>{t.contact.regNumber}</h3>
                  <p>CHE-447.388.222</p>
                </div>
                <div className="contact-item">
                  <h3>{t.contact.address}</h3>
                  <p>Via Besso 31<br/>6900 Lugano<br/>Switzerland</p>
                </div>
                <div className="contact-item">
                  <h3>{t.contact.email}</h3>
                  <p><a href="mailto:info@imat92.ch">info@imat92.ch</a></p>
                </div>
              </div>
            </div>

            <div className="contact-form-container">
              <h3>{t.contact.formTitle}</h3>
              <form className="contact-form">
                <div className="form-group">
                  <label htmlFor="name">{t.contact.formName}</label>
                  <input type="text" id="name" name="name" required />
                </div>
                <div className="form-group">
                  <label htmlFor="email">{t.contact.formEmail}</label>
                  <input type="email" id="email" name="email" required />
                </div>
                <div className="form-group">
                  <label htmlFor="company">{t.contact.formCompany}</label>
                  <input type="text" id="company" name="company" />
                </div>
                <div className="form-group">
                  <label htmlFor="message">{t.contact.formMessage}</label>
                  <textarea id="message" name="message" rows="5" required></textarea>
                </div>
                <button type="submit" className="btn-primary">{t.contact.formSubmit}</button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-main">
              <div className="footer-brand">
                <span className="logo-text">IMAT92 Sagl</span>
                <p className="footer-tagline">
                  {t.footer.tagline}
                </p>
              </div>
            </div>
            <div className="footer-bottom">
              <p className="copyright">
                © {new Date().getFullYear()} IMAT92 Sagl. {t.footer.copyright}
              </p>
              <p className="disclaimer">
                {t.footer.disclaimer}
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
